let ticket = [
  {
    path: '/wechat/order-ticket',
    name: '微信小票',
    component: () => import('@/pages/ticket/wechat/main_ticket')
  },
  {
    path: '/wechat/test-ticket',
    name: '微信点金计划测试页',
    component: () => import('@/pages/ticket/wechat/test_ticket')
  }
]

export default ticket
